import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { quizEntrance } from "../shared/quizMotion";
import { QuestionCard } from "../shared/QuestionCard";
import { StyledTextField } from "../form/StyledTextField";
import { QUIZ } from "@/theme/quizTokens";

type Props = {
  dogs: { id: string; form: any }[];
  updateDog: (dogId: string, update: any) => void;
};

/**
 * Figma screen 19 — "WHAT IS YOUR DOG'S NAME?", repeated per dog when the
 * household has more than one, with the shared helper line at the bottom.
 */
export default function StepNames({ dogs, updateDog }: Props) {
  return (
    <motion.div {...quizEntrance()}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "34px", md: "44px" } }}>
        {dogs.map((dog, i) => (
          <QuestionCard
            key={dog.id}
            title="What is your dog's name?"
            field={i === 0 ? "name" : `name-${i}`}
          >
            <StyledTextField
              fullWidth
              placeholder="Type your answer here"
              value={dog.form?.name ?? ""}
              onChange={(e) => updateDog(dog.id, { name: e.target.value })}
              inputProps={{ autoCapitalize: "words", autoCorrect: "off" }}
            />
          </QuestionCard>
        ))}

        <Typography
          sx={{
            width: "100%",
            textAlign: "center",
            fontFamily: QUIZ.font.body,
            fontSize: { xs: "16px", md: "18px" },
            lineHeight: 1.3,
            color: QUIZ.color.grey,
            maxWidth: 500,
            mx: "auto",
          }}
        >
          Your answers will help us create a fresh, personalised food plan tailored to your dog.
        </Typography>
      </Box>
    </motion.div>
  );
}
